const TRACK_LABS_LOGO_URL = "https://tracklabs-2rqxgdhv.manus.space/manus-storage/track-labs-logo-no-tagline_b38a3502.png";

type TrackLabsLoaderProps = {
  label?: string;
  compact?: boolean;
};

export function TrackLabsLoader({ label = "Loading Track Labs", compact = false }: TrackLabsLoaderProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={`tracklabs-loader ${compact ? "flex items-center justify-center py-10" : "grid min-h-screen place-items-center bg-background px-6"}`}
      style={{ colorScheme: "light" }}
    >
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="relative grid h-24 w-24 place-items-center">
          <span className="absolute inset-0 rounded-full border-2 border-primary/20" aria-hidden="true" />
          <span className="absolute inset-1 rounded-full border-2 border-transparent border-t-primary border-r-primary/50 animate-spin" aria-hidden="true" />
          <img
            src={TRACK_LABS_LOGO_URL}
            alt="Track Labs"
            decoding="async"
            className="h-14 w-14 object-contain drop-shadow-md animate-track-labs-logo-bounce"
          />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-bold tracking-[0.24em] text-foreground uppercase">
            <span className="inline-block animate-track-labs-letter" style={{ animationDelay: "0ms" }}>Track</span>{" "}
            <span className="inline-block animate-track-labs-letter" style={{ animationDelay: "120ms" }}>Labs</span>
          </p>
          <p className="text-xs text-muted-foreground">{label.replace("Track Labs", "").trim() || "Please wait"}<span className="loading-dots" aria-hidden="true">...</span></p>
        </div>
      </div>
    </div>
  );
}
